import { Children } from 'react'
import PropTypes from 'prop-types'

import useStyles from './styles'

const ContentBlock = ({ children }) => {
  const initialClasses = useStyles()

  return (
    <div className={initialClasses.root}>
      {Children.map(children, (child, i) => (
        <div key={i} className={child.props.wrapclass}>
          {child}
        </div>
      ))}
    </div>
  )
}

ContentBlock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
ContentBlock.defaultProps = {
  className: '',
}

export default ContentBlock
